import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { useTranslation } from '../../contexts/LanguageContext';

const NavLinks = () => {
    const { t } = useTranslation();

    return (
        <>
            <HashLink smooth to="/#hero" className="text-blue-900 hover:text-orange-600 px-4 py-2 font-semibold">
                {t('navbar.home')}
            </HashLink>
            <HashLink smooth to="/#features" className="text-blue-900 hover:text-orange-600 px-4 py-2 font-semibold">
                {t('navbar.features')}
            </HashLink>
            <HashLink smooth to="/#about" className="text-blue-900 hover:text-orange-600 px-4 py-2 font-semibold">
                {t('navbar.about')}
            </HashLink>
            <Link to="/contact" className="text-blue-900 hover:text-orange-600 px-4 py-2 font-semibold">
                {t('navbar.contact')}
            </Link>

            {/* NEW: Blog link pointing to blog.easysubs.it */}
            <a 
                href="https://blog.easysubs.it" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-900 hover:text-orange-600 px-4 py-2 font-semibold"
            >
                {t('navbar.blog')}
            </a>

            <Link to="/demo" className="text-white bg-orange-600 hover:bg-orange-700 px-6 py-2 rounded-lg font-semibold transition-colors">
                {t('navbar.login')}
            </Link>
        </>
    );
}

export default NavLinks;